/**
 *
 * ClubLocation
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Marker } from 'react-leaflet';

import clubIconImage from 'images/icons/yellow_r.png';
import leafletIcon from 'utils/leafletIcon';

class ClubMarker extends React.PureComponent {
  constructor(props) {
    super(props);
    this.icon = leafletIcon({ iconUrl: clubIconImage });
  }

  render() {
    const { club, loc, ...rest } = this.props;
    return (
      <Marker title={club.name} position={loc} icon={this.icon} {...rest} />
    );
  }
}

ClubMarker.propTypes = {
  club: PropTypes.object.isRequired,
  loc: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};

export default ClubMarker;
